import { LocalStorageService } from 'angular-2-local-storage';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, OnInit } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { environment } from 'src/environments/environment';
import { User } from '../services/auth.service';

const currentUserKey = 'ops.id.currentUser';

@Injectable()
export class CustomErrorHandler implements ErrorHandler, OnInit {

  user: User;
  isInit = false;

  constructor(
    private injector: Injector,
  ) {
  }

  ngOnInit() {

  }

  handleError(error) {
    if (!this.isInit) {
      Sentry.init({
        dsn: environment.uiSentryDsn,
        environment: environment.production ? 'production' : 'dev'
      });
      this.isInit = true;
    }
    if (error instanceof HttpErrorResponse) {
      // Backend returns unsuccessful response codes such as 404, 500 etc.
    } else {
      // Chunk failed refresh browser
      const chunkFailedMessage = /Loading chunk [\d]+ failed/;
      if (chunkFailedMessage.test(error.message)) {
        window.location.reload();
      }

      // A client-side or network error occurred.
      if (environment.production) {
        this.handleSentryError(error);
      }

      if (!environment.production) {
        if (error.stack) {
          console.error(error.stack);
        } else if (error.message) {
          console.error(error.message);
        }
      }
    }
  }

  handleSentryError(error) {
    if (environment.production) {
      const localStorage = this.injector.get(LocalStorageService);
      this.user = localStorage.get(currentUserKey) as User;
      if (this.user) {
        Sentry.withScope(scope => {
          const email = (this.user.emailAddresses && this.user.emailAddresses.length > 0 && this.user.emailAddresses[0])
            ? this.user.emailAddresses[0] : '';
          scope.setUser({
            'email': email,
            'id': this.user ? this.user.contactId.toString() : '',
            'username': this.user ? this.user.fullName : ''
          });
          // will be tagged with my-tag="my value"
          Sentry.captureException(error.originalError || error);
        });
      } else {
        Sentry.captureException(error.originalError || error);
      }
    }
  }


}
